import { THEMES } from 'src/constants';

export const BRP_CLIENT = 'brp-group';

export const brp = {
    siteName: 'brp',
    senderName: 'BRP Group',
    logo: '/static/warbox_brp_logo.png',
    name: 'BRP Group',
    bureauSite: 'brp.warbox.io',
    theme: THEMES.BRP_LIGHT,
    client: BRP_CLIENT,
    themes: [
        { theme: 'BRP_LIGHT', name: 'BRP LIGHT' },
        { theme: 'BRP_DARK', name: 'BRP DARK' },
        { theme: 'LIGHT', name: 'LIGHT' },
        { theme: 'ONE_DARK', name: 'DARK' },
        { theme: 'DARK_PINK', name: 'DARK PINK' },
        { theme: 'LIGHT_PINK', name: 'LIGHT PINK' },
        { theme: 'DARK_BLUE', name: 'DARK BLUE' },
        { theme: 'LIGHT_BLUE', name: 'LIGHT BLUE' },
        { theme: 'DARK_RED', name: 'DARK RED' },
        { theme: 'LIGHT_RED', name: 'LIGHT RED' },
        { theme: 'DARK_LILA', name: 'DARK LILA' },
        { theme: 'LIGHT_LILA', name: 'LIGHT LILA' },
    ],
};
